import React, { useEffect } from 'react';

import {
  onMessage,
  getMessaging,
  isSupported,
  MessagePayload,
  Unsubscribe,
} from 'firebase/messaging';
import toast from 'react-hot-toast';
import { NotificationPriorities, notificationReceived } from '@pharmaplan/common';

import ToastNotification from '../../components/ToastNotification';
import genericClasses from '../../theme/GenericClasses';
import ThemeConstants from '../../theme/ThemeConstants';
import { useAppDispatch } from '../useAppDispatch';

const seconds = 10;
const ms = 1000;
const duration = seconds * ms;

const showNotificationToast = (
  data: MessagePayload['data'],
  isPriority: boolean,
) => {
  const style = isPriority
    ? {
      ...genericClasses.toastWidth,
      backgroundColor: ThemeConstants.common.priorityBg,
      borderLeft: `3px solid ${ThemeConstants.common.counterRed}`,
      color: ThemeConstants.common.grey850,
    }
    : {
      ...genericClasses.toastWidth,
      backgroundColor: ThemeConstants.common.lightGreen,
      color: ThemeConstants.primary.main,
    };

  toast((t) =>
    <ToastNotification data={data as any} toastParams={t} />, {
    duration: isPriority ? Infinity : duration,
    style,
  });
};

const useForegroundNotifications = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let unsubscribe: Unsubscribe | null = null;

    isSupported().then((supported) => {
      if (!supported) {
        return;
      }

      unsubscribe = onMessage(getMessaging(), (payload) => {
        const { data } = payload ?? {};
        const { priority = NotificationPriorities.normal } = data ?? {};
        const { notificationId } = data ?? {};

        // TELLS THE BACKEND THE PUSH REACHED THIS BROWSER. THE BACKGROUND
        // COUNTERPART LIVES IN public/firebase-messaging-sw.js, WHICH CANNOT
        // REACH REDUX AND CALLS THE ROUTE DIRECTLY.
        if (notificationId) {
          dispatch(notificationReceived(notificationId));
        }

        showNotificationToast(data, priority === NotificationPriorities.critical);
      });
    });

    return () => {
      unsubscribe?.();
    };
  }, [dispatch]);
};

export default useForegroundNotifications;
